import { render } from "./Navbar9View.vue?vue&type=template&id=83d7d9dc"
const script = {}

import exportComponent from "E:\\2023-1\\sukun\\Sukun-Psikotes-FE-Peserta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__